import { Box } from "rebass/styled-components";

import { FAQ, IFaqItem } from "../data";
import { FaqItem, Section, SectionHeading } from "../../styledComponents";

export const Faq = () => (
  <Section py={[72, 96, 120]} alignItems="center">
    <SectionHeading textAlign="center">FAQ</SectionHeading>

    <Box mt={[7, 8, 8]} maxWidth={860} width="100%">
      {FAQ.map((item: IFaqItem) => (
        <FaqItem key={item.question}>
          <summary>{item.question}</summary>
          <div className="answer">{item.answer}</div>
        </FaqItem>
      ))}
    </Box>
  </Section>
);
